import script from "./AsesoriaRegistralPrivadoView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsesoriaRegistralPrivadoView.vue?vue&type=script&setup=true&lang=js"

import "./AsesoriaRegistralPrivadoView.vue?vue&type=style&index=0&id=fa3905f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa3905f0"]])

export default __exports__